import { render, staticRenderFns } from "./PayrollMovementSummary.vue?vue&type=template&id=49484658&scoped=true"
import script from "./PayrollMovementSummary.vue?vue&type=script&lang=js"
export * from "./PayrollMovementSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49484658",
  null
  
)

export default component.exports